import { ICommercialSpecialtySchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { FOfferType } from '../../../utils/offer_type';

interface IShouldSpecialtyRender {
  specialty: ICommercialSpecialtySchema | null;
  specialtiesString?: string;
  offerType: FOfferType;
}

export const shouldSpecialtyRender = (params: IShouldSpecialtyRender) => {
  const { specialty, offerType, specialtiesString } = params;

  return (
    specialty &&
    (specialty.specialties || specialty.additionalTypes) &&
    [FOfferType.Business, FOfferType.FreeAppointmentObject, FOfferType.TradeArea].includes(offerType) &&
    !!specialtiesString
  );
};
